import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CignaIcon } from '@cigna/ui/icon';
import { ServiceError, Message, MessageUpdate } from '@cigna/chcp/shared/util';
import { AsyncData } from '@cigna/core/interfaces';

type MessageCenterViewType = 'past24h' | 'past7d' | 'past30d' | 'flagged';

@Component({
  selector: 'cigna-message-center-widget',
  templateUrl: './message-center-widget.component.html',
  styleUrls: ['./message-center-widget.component.scss', '../tile.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageCenterWidgetComponent {
  @Input() messages: AsyncData<Message[], ServiceError>;
  @Input() view: MessageCenterViewType = 'past24h';
  @Input() isImpersonator: boolean;

  @Output() updateMessages: EventEmitter<MessageUpdate> = new EventEmitter();
  @Output() deleteMessages: EventEmitter<string[]> = new EventEmitter();

  CignaIcon = CignaIcon;

  viewToDisplayMap: Record<MessageCenterViewType, string> = {
    past24h: 'Past 24 hours',
    past7d: 'Past 7 day',
    past30d: 'Past 30 day',
    flagged: 'Flagged',
  };

  public trackByFunc(index: number, message: Message): string {
    return message.id;
  }
}
